import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { QualificationRequirement } from './types/QualificationRequirement';
import { UserDocumentCategory } from './types/UserDocument';

export default (makeCall: MakeCall) =>
  (
    listingUuid: string,
    data: [
      {
        category: UserDocumentCategory | string;
        isOptional: boolean;
      },
    ],
  ) =>
    makeCall<QualificationRequirement>(
      'POST',
      `/api/v2/qualification/requirements/`,
      {
        data: {
          documents: data,
          listingUuid,
        },
      },
    );
